module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Loehningen-a89b7856ed965d07a15194137ba6b3ae.png";